import { useMutation } from "@tanstack/react-query";
import { postFetchData } from "../../utils/api/FetchData";
import { ToastNotifier } from "../ui/ToastNotifier";
import { getFetchData } from "../utils/api/FetchData";
import Sidebar from "./SideBar";
import { APICONSTANT } from "../utils/api/Config";
import { useDispatch } from "react-redux";



const MenuCustomHook = () => {
  const  dispatch = useDispatch()

  const menuList = async () => {
    const response = await getFetchData(1, dispatch,APICONSTANT.menu_list); // Pass dynamic API URL
    if (response?.status === 1) {
      return response.data;
    }
  };

    return { menuList };
};

export default MenuCustomHook; // Export the custom hook
